import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Difference list',
  name: 'differenceList',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Items',
      name: 'items',
      type: 'array',
      of: [{ type: 'difference' }],
      validation: (Rule) => Rule.length(6),
    }),
  ],
})